const SITE_URL = "https://askthepods.com";

const SOCIAL_SHARE_IMAGES = [
  `${SITE_URL}/__l5e/assets-v1/624ddb3a-2ea4-4ab9-b103-3f56cec607a1/share-image-1.png`,
  `${SITE_URL}/__l5e/assets-v1/52f91e78-36d1-4f82-aca4-4cc8e4f66b26/share-image-2.png`,
  `${SITE_URL}/__l5e/assets-v1/300baac4-1473-4984-b9d1-982c25061256/share-image-3.png`,
  `${SITE_URL}/__l5e/assets-v1/dba45689-e98e-490d-8dc3-a48a8db47b62/share-image-4.png`,
  `${SITE_URL}/__l5e/assets-v1/331176be-6284-435f-9302-1f93f67db0f7/share-image-5.png`,
  `${SITE_URL}/__l5e/assets-v1/1f6e1851-8122-4733-a9da-31dd1056bad1/share-image-6.png`,
  `${SITE_URL}/__l5e/assets-v1/0c97c8db-4db0-465f-ad8f-7ad4668fe33a/share-image-7.png`,
] as const;

function normalizeSeed(seed: string): string {
  try {
    const url = new URL(seed, SITE_URL);
    const path = url.pathname.replace(/\/+$/, "") || "/";
    const query = url.searchParams.toString();
    return query ? `${path}?${query}` : path;
  } catch {
    return seed || "/";
  }
}

function fnv1a(seed: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < seed.length; i += 1) {
    hash ^= seed.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash >>> 0;
}

export function getRotatingSocialImage(seed: string): string {
  const normalized = normalizeSeed(seed);
  const index = fnv1a(normalized) % SOCIAL_SHARE_IMAGES.length;
  return SOCIAL_SHARE_IMAGES[index];
}

export function getHomepageSocialImage(): string {
  return getRotatingSocialImage("/");
}

export { SOCIAL_SHARE_IMAGES };
